export const ADDON_LIST_REQUEST = "ADDON_LIST_REQUEST";
export const ADDON_LIST_SUCCESS = "ADDON_LIST_SUCCESS";
export const ADDON_LIST_FAIL = "ADDON_LIST_FAIL";
export const ADDON_LIST_RESET = "ADDON_LIST_RESET";

export const ADDON_SINGLE_REQUEST = "ADDON_SINGLE_REQUEST";
export const ADDON_SINGLE_SUCCESS = "ADDON_SINGLE_SUCCESS";
export const ADDON_SINGLE_FAIL = "ADDON_SINGLE_FAIL";
export const ADDON_SINGLE_RESET = "ADDON_SINGLE_RESET";
